import {retryExchange} from '@urql/exchange-retry';
import {createClient as createWSClient} from 'graphql-ws';
import {Client, subscriptionExchange} from 'urql';

import {zeroConfigExchanges} from './exchanges';

import {BACKEND_URL} from '@/config/constants/URL-CONSTANTS';
import {useAuthenticationStore} from '@/hooks/global-stores/authentication.store';

export const makeUrqlClient = () => {
  const token = useAuthenticationStore.getState().accessToken;

  const wsClient = createWSClient({
    url: `wss://${BACKEND_URL}/graphql/query`,
    connectionParams: {
      authorization: token ? `Bearer ${token}` : '',
    },
    retryAttempts: 10000,
  });

  return new Client({
    url: `https://${BACKEND_URL}/graphql/query`,
    exchanges: [
      ...zeroConfigExchanges,
      subscriptionExchange({
        forwardSubscription: request => {
          const input = {...request, query: request.query || ''};
          return {
            subscribe: sink => {
              const unsubscribe = wsClient.subscribe(input, sink);
              return {unsubscribe};
            },
          };
        },
      }),
      retryExchange({
        initialDelayMs: 1000,
        maxDelayMs: 15000,
        randomDelay: true,
        maxNumberAttempts: 10000,
      }),
    ],
    fetchOptions: () => ({
      headers: {
        authorization: token ? `Bearer ${token}` : '',
      },
    }),
  });
};
